export const COOKIE_AUTH_TOKEN = 's9EbqQjzVs9xAJYM';
export const COOKIE_NEXT_LOCALE = 'Cpq54n7VM3sA7hTC';
export const COOKIE_VISITOR = 'mTLDmyPW2KCMP9vG';
export const COOKIE_SALES_MANGO = 'smclient';
